(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["agea-motion-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('agea-motion-home')) {
  customElements.define('agea-motion-home', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const button = this.querySelector('.ae-motion-toggle');
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!button) return;
      const update = (paused) => {
        this.classList.toggle('ae-still', paused);
        button.textContent = paused ? button.dataset.play : button.dataset.pause;
        button.setAttribute('aria-pressed', String(paused));
      };
      update(preference.matches);
      button.addEventListener('click', () => update(!this.classList.contains('ae-still')));
      this.motionPreference = preference;
      this.preferenceChanged = (event) => update(event.matches);
      preference.addEventListener('change', this.preferenceChanged);
    }
    disconnectedCallback() {
      if (this.motionPreference) this.motionPreference.removeEventListener('change', this.preferenceChanged);
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
